import vue from 'vue'
import router from 'vue-router'
import login from '../views/basic/login'
import index from '../views/basic/home'
import empty from '../views/basic/empty'
import personal from '../views/basic/personal'
import layout from "../views/basic/layout";
const _import = require('@/router/_import_' + process.env.NODE_ENV)//获取组件的方法
 
vue.use(router)
const originalPush = router.prototype.push
router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const createRouter = () => new router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/empty', component: empty, name: 'empty',
            meta: {
                title: 'empty',
                auth: false,
                pageName:'empty',
                template: true // 添加该字段，表示不需要home模板
            },
           children:null
        },
		
       
        {
            path: '/',
            component: index,children:null,
            name: '首页',
            icon: 'fa-qq',//图标样式class
          
            meta: {
                englishName:'index',   
                title: '首页',
                name: '首页',
				    pageName:'/',
                auth: true // 添加该字段，表示进入这个路由是需要登录的
            }
        },
        {
            path: '/personal',
            component: personal,children:null,
            name: '个人中心',
            icon: 'fa-qq',//图标样式class
          
            meta: {
                englishName:'personal Center',   
                title: '个人中心',
                name: '个人中心',
				    pageName:'personal',
                auth: true // 添加该字段，表示进入这个路由是需要登录的
            },
			
        
		},
        {
            path: '/login',
            component: login,
            name: 'login',children:null,
            icon: 'fa-address-card',//图标样式class
            meta: {
                title: '登录',
             	    pageName:'login',
                template: true // 添加该字段，表示不需要home模板
            },
          
        },
	
        {
            path: '*',
           children:null,
            redirect: {path: '/empty'}
        }
    ]
})

const  powerRouter = createRouter()
let list=[];
export function  filterAsyncRouter(asyncRouterMap) {
    //注意这里的 asyncRouterMap 是一个数组
    const accessedRouters = asyncRouterMap.filter(route => {
		let index=list.findIndex(item=>{return item==route.path});
        if (route.path) {
             if (!route.path||route.path == '/'||route.path == '-') {//Layout组件特殊处理
                route.component = layout
            } else if(index==-1){
                try {  
                    route.component = _import(route.path)
                }catch (e) {
					try{
						route.component = () => import('@/views' + route.path + '.vue'); 
					}catch(e){
					  console.info('%c 当前路由 '+route.path+'.vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!', "color:red")
					}
                }
				list.push(route.path);
            }
        }
        if (route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })
list=[];

    return accessedRouters
}

export function resetRouter () {
    const newRouter = createRouter()
    powerRouter.matcher = newRouter.matcher // the relevant part
}
var dynamicRouter=null
if (!dynamicRouter&&localStorage.ROUTER) {//不加这个判断，路由会陷入死循环
        dynamicRouter = !localStorage.ROUTER?null:JSON.parse(localStorage.ROUTER)//拿到路由
        dynamicRouter = filterAsyncRouter(dynamicRouter) //过滤路由
        powerRouter.addRoutes(dynamicRouter) //动态添加路由 
    }   
   
powerRouter.beforeEach((to, from, next) => {
        if (to.meta.auth) {
            // 判断该路由是否需要登录权限
            if (localStorage.getItem('TOKEN')) {
                // 通过vuex state获取当前的token是否存在
                next();
            } else {
                localStorage.clear();
                next({
                    path: "/login",
                    query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
                });
                 location.reload()
            }
        } else {
            next();
        }
           if(dynamicRouter&&to.name&&to.name != 'login'){
               dynamicRouter =  !localStorage.ROUTER?null:JSON.parse(localStorage.ROUTER)//拿到路由
           }
            next()

});
export default powerRouter;

 